module.exports = __webpack_public_path__ + "static/media/cdc.8ec2f753.png";